import React from 'react';

const StopVoice = () => {
    return (
        <svg width={21} height={21} viewBox="0 0 21 21">
            <g transform="translate(-182 -688)">
                <circle
                    cx={10.5}
                    cy={10.5}
                    r={10.5}
                    transform="translate(182 688)"
                    fill="#fff"
                />
                <path fill="#8f99dc" d="M189 695h7v7h-7z" />
            </g>
        </svg>
    );
};

export default StopVoice;
